import logo from "../icon.png";
import React from "react";
import ConvertFrom from "./ConvertFrom";
import ConvertTo from "./ConvertTo";

function HeroSection({onFormatChange , formatType, setConvertFrom}) {

    const handleFormatChange = (format) => {
        console.log("Selected format:", format);
        onFormatChange(format)
        // You can call convert function here
    };

    const handleConvert = (format) => {
        setConvertFrom(format)
    }


    return (
        <>
            <style>{`
                .hero-section{
                    display: flex;
                    background: linear-gradient(to right, #272727, #393939);
                    width: 100%;
                    height: 300px;
                }
                
                .hero-left{
                    display: flex;
                    flex: 1;
                    justify-content: center;
                    flex-direction: column;
                    place-items: center;
                    gap: 10px;
                
                }
                
                .hero-right{
                    display: flex;
                    flex: 1;
                    flex-direction: row;
                }
                .heading{
                    width: 55%;
                    display: flex;
                    margin: 0px;
                    justify-content: flex-start;
                }
                
                h1 {
                    color: white;
                
                }
                
                .description{
                    color: white;
                
                }
                
                .row-container{
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                    gap: 8px;
                }
                
                .text-convert ,.text-to{
                    color: white;
                    font-size: 20px;
                }

            `}</style>

            <div className="hero-section">
                <div className="hero-left">
                    <div className="heading">
                        <h1>JPG to PNG Converter</h1>
                    </div>
                    <div>
                        <p className="description">CloudConvert converts your image files online. Amongst many others, we<br/>support PNG, JPG, GIF, WEBP and HEIC. You can use the options to control<br/>image resolution, quality and file size.</p>
                    </div>
                </div>
                <div className="hero-right">
                    <div className="row-container">
                        <p className="text-convert">convert</p>

                        <ConvertFrom onFormatChange={handleConvert}/>

                        <p className="text-to">to</p>

                        <ConvertTo onFormatChange={handleFormatChange} formatType = {formatType}/>

                    </div>
                </div>
            </div>
        </>

    );
}

export default HeroSection;
